export class ProductionValidationView {
	id: number;
	displayName: string;
	validator: ProductionValidator;
	content: string;
	initiated: boolean;
	type: ProductionValidatorType;
}

export enum ProductionValidator {
	EmailFamilies,
	RedactForPrivilegeWithheldStatus,
	RedactForPrivilegeRedactionStatus,
	RedactedPdf,
	RedactedNative,
	ResponsiveInvalid,
	ResponsiveNotResponsiveNative,
	ResponsiveEmailFamily,
	PrivilegeEmailFamily,
	WorkProductEmailFamily,
	PageCount,
	RedactForPiRedactionStatus
}

export enum ProductionValidatorType {
	Error,
	Warning
}
